module.exports = __webpack_public_path__ + "static/media/Image_No_Image_Placeholder_Large.213fd999.png";